module.exports = __webpack_public_path__ + "img/icon-white-64.c08555ec.svg";